import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import { Button, Modal } from '@pancakeswap-libs/uikit'
import Input from 'components/Input'
import ModalActions from 'components/ModalActions'
import useI18n from 'hooks/useI18n'

interface ModalProps {
  onConfirm?: (amount: string) => Promise<any>
  onDismiss?: () => void
}

const TheModal: React.FC<ModalProps> = ({ onConfirm, onDismiss }) => {
  const [newOwner, setNewOwner] = useState('')
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    setNewOwner(e.currentTarget.value); 
  }
  const [pendingTx, setPendingTx] = useState(false)
  const [, setRequested] = useState(false)
  const TranslateString = useI18n()

  const isValid = (input) => {
    return Web3.utils.isAddress(input)
  }

  const handleSubmit = useCallback(async () => {
    try {
      setRequested(true)
      const txHash = await onConfirm(newOwner);
      // user rejected tx or didn't go thru
      if (txHash) {
        setRequested(false)
      }
    } catch (e) {
      console.error(e)
    }
  }, [onConfirm, setRequested, newOwner])

  return (
    <Modal title={TranslateString(400,'Transfer Ownership')} onDismiss={onDismiss}>
      <Input placeholder={TranslateString(401,'New Onwer Address')} value={newOwner} onChange={handleChange} />
      <ModalActions>
        <Button fullWidth variant="secondary" onClick={onDismiss}>
          {TranslateString(462, 'Cancel')}
        </Button>
        <Button
          fullWidth
          disabled={pendingTx || !isValid(newOwner)}
          onClick={async () => {
            setPendingTx(true)
            await handleSubmit()
            setPendingTx(false)
            onDismiss()
          }}
        >
          {pendingTx ? TranslateString(488, 'Pending Confirmation') : TranslateString(464, 'Confirm')}
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default TheModal

const Tips = styled.div`
  margin-top: 2em;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
`

const Final = styled.div`
  margin-top: 3px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
`
const Announce = styled.div`
  margin-top: 1em;
  color: #f41e5b;
  text-align: center;
`
